/**
 * @file   src\components\Introduction\IntroductionDetail.js
 * @brief  This file is responsible for the view of accepted introductions list data.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";
import _ from "lodash";
import {
  getpropertyName,
  removeDecimalZeros,
  thousandSeperatedValue,
} from "../../helpers/common";
import { IS_LAND } from "../../constants/common";
import noImage from "../../images/no-image-small.png";

const IntroductionDetail = (props) => {
  const { introDetails } = props;

  // Initialize variables.
  const bedRoom = removeDecimalZeros(_.get(introDetails, "Bedrooms", ""));
  const bathRoom = removeDecimalZeros(_.get(introDetails, "Bathrooms", ""));
  const sqFt = removeDecimalZeros(_.get(introDetails, "Sqft", ""));
  const acreage = removeDecimalZeros(_.get(introDetails, "TotalAcre", ""));
  let lotSizeUnit = _.get(introDetails, "Acre_Sqft", "");
  if (lotSizeUnit && lotSizeUnit !== 0) {
    lotSizeUnit = lotSizeUnit === 1 ? " Acres" : " Sqft";
  }
  const askingPrice = _.get(introDetails, "AskingPrice", "");
  const inventoryImage =
    _.get(introDetails, "Photo_1", "") !== "null" &&
    _.get(introDetails, "Photo_1", "") !== "undefined" &&
    _.get(introDetails, "Photo_1", "") !== null
      ? _.get(introDetails, "Photo_1", "")
      : noImage;

  return (
    <>
      <figure className="flex-shrink-0">
        <img src={inventoryImage} alt={inventoryImage} />
      </figure>
      <div className="detail">
        <h5>
          {" "}
          {getpropertyName(introDetails)} in {_.get(introDetails, "City", "")},{" "}
          {_.get(introDetails, "State", "")}
        </h5>
        <ul className="wantad-btm-list mt-2">
          {bedRoom ? <li> {bedRoom} Beds</li> : <></>}

          {bathRoom ? <li>{bathRoom} Baths </li> : <></>}
          {sqFt ? <li> {sqFt} sqft</li> : <></>}

          {acreage ? <li>{acreage + lotSizeUnit}</li> : <></>}
        </ul>
        <p> ${askingPrice && thousandSeperatedValue(askingPrice)}</p>
      </div>
    </>
  );
};
export default IntroductionDetail;
